var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80141 11.3307L7.79952 11.3284C7.42322 10.8804 6.72474 10.886 6.36826 11.3645L4.29892 14.0239C4.29854 14.0244 4.29817 14.0249 4.29779 14.0253C3.82804 14.6238 4.24408 15.5083 5.01667 15.5083H15.0083C15.7543 15.5083 16.2025 14.6517 15.741 14.0408C15.7408 14.0405 15.7405 14.0401 15.7402 14.0397L12.8184 10.1441C12.8181 10.1436 12.8178 10.1431 12.8174 10.1427C12.4525 9.65193 11.723 9.64974 11.3545 10.1275C11.3542 10.1278 11.3539 10.1281 11.3537 10.1285L9.15378 12.96L7.8014 11.3307L7.80141 11.3307ZM17 4.16667V15.8333C17 16.4739 16.4739 17 15.8333 17H4.16667C3.52614 17 3 16.4739 3 15.8333V4.16667C3 3.52614 3.52614 3 4.16667 3H15.8333C16.4739 3 17 3.52614 17 4.16667Z",
    fill: "#2B8C34",
    stroke: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.b80e5a9ee8d071dd6367601a38a7a9f7.svg";
export { ForwardRef as ReactComponent };